import { CONFIG } from '../config.js';
import { readJSON, writeJSON } from '../utils/storage.js';

/**
 * Gestione del tema chiaro/scuro con persistenza.
 * Al primo accesso segue la preferenza di sistema dell'utente.
 */

const THEMES = { DARK: 'dark', LIGHT: 'light' };

/** @returns {'dark'|'light'} */
function getSystemTheme() {
  if (typeof matchMedia !== 'function') return THEMES.DARK;
  return matchMedia('(prefers-color-scheme: light)').matches ? THEMES.LIGHT : THEMES.DARK;
}

/** @param {'dark'|'light'} theme */
function applyTheme(theme) {
  document.documentElement.setAttribute('data-theme', theme);
  const icon = document.querySelector('[data-theme-icon]');
  if (icon) icon.textContent = theme === THEMES.DARK ? '🌙' : '☀️';
}

/**
 * Applica il tema salvato e collega il pulsante di switch.
 *
 * @param {HTMLElement|null} toggleButton
 * @returns {'dark'|'light'} tema attivo
 */
export function initTheme(toggleButton) {
  const saved = readJSON(CONFIG.STORAGE_KEYS.THEME, null);
  let current = saved === THEMES.LIGHT || saved === THEMES.DARK ? saved : getSystemTheme();

  applyTheme(current);

  toggleButton?.addEventListener('click', () => {
    current = current === THEMES.DARK ? THEMES.LIGHT : THEMES.DARK;
    applyTheme(current);
    writeJSON(CONFIG.STORAGE_KEYS.THEME, current);
  });

  return current;
}
